import { Dispatch } from "redux";

import api from "@helpers/api";

import { QuotaStateAction } from "@reducers/types/inventory/quota-state";

import { GET_QUOTA, CREATE_QUOTA, UPDATE_QUOTA } from "./types";

const endPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}/settings/quota`;

export const quotaFetchActionHandler = (query: any) => async (
  dispatch: Dispatch<QuotaStateAction>
) => {
  dispatch({ type: GET_QUOTA.LOADING, payload: true });

  try {
    // code needs to be done
    const res = await api.get(`${endPoint}`, {
      params: query,
    });

    dispatch({ type: GET_QUOTA.SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: GET_QUOTA.ERROR, payload: err });
  }
};

export const quotaCreateActionHandler = (data: {
  gradeId: string;
  categoryId: number | string;
  groupId: number | string;
  amount: number | string;
}) => async (dispatch: Dispatch<QuotaStateAction>) => {
  dispatch({ type: CREATE_QUOTA.LOADING, payload: true });

  try {
    // need to code here
    const res = await api.post(`${endPoint}`, {
      body: data,
    });
    dispatch({ type: CREATE_QUOTA.SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: CREATE_QUOTA.ERROR, payload: err });
  }
};

export const quotaUpdateActionHandler = (
  id: string | number,
  data: { quota: string; category: number; group: number; amount: number }
) => async (dispatch: Dispatch<QuotaStateAction>) => {
  dispatch({ type: UPDATE_QUOTA.LOADING, payload: true });

  try {
    const res = await api.put(`${endPoint}/${id}`, {
      body: data,
    });

    dispatch({
      type: UPDATE_QUOTA.SUCCESS,
      payload: {
        ...res.data,
        quota: data.quota,
      },
    });
  } catch (err) {
    dispatch({ type: UPDATE_QUOTA.ERROR, payload: err });
  }
};
